var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-container body-container" },
    [
      _c("div", { staticClass: "remain-count-box" }, [
        _c("div", { staticClass: "remain-count-main" }, [
          _c("span", { staticClass: "remain-count-text" }, [
            _vm._v("剩余统计次数："),
          ]),
          _c("em", { staticClass: "remain-count" }, [
            _vm._v(_vm._s(_vm.performanceCount)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "project" }, [
          _c("div", { staticClass: "project-title" }, [_vm._v("全部项目")]),
          _c("div", { staticClass: "project-list-container" }, [
            _c(
              "ul",
              { staticClass: "project-list" },
              [
                _vm._l(_vm.projectList, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.game_id,
                      on: {
                        click: function ($event) {
                          return _vm.gotoProject(item.game_id)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "project-item-img",
                        attrs: { src: _vm.getUrl(item.game_img), alt: "" },
                      }),
                      _c("div", { staticClass: "project-item-name" }, [
                        _c("div", { staticClass: "project-item-name-text" }, [
                          _vm._v(_vm._s(item.game_name)),
                        ]),
                      ]),
                      _c("div", { staticClass: "project-item-type" }, [
                        _vm._v(
                          "项目类型：" +
                            _vm._s(_vm.cateMap[item.root_cate].name)
                        ),
                      ]),
                      _c("div", { staticClass: "project-item-created-at" }, [
                        _vm._v(
                          "创建时间：" +
                            _vm._s(
                              _vm.parseTime(item.created_at, "{y}-{m}-{d}")
                            )
                        ),
                      ]),
                    ]
                  )
                }),
                _c(
                  "li",
                  { staticClass: "add-project", on: { click: _vm.dialogShow } },
                  [
                    _c("img", {
                      attrs: { src: require("@/assets/add.svg"), alt: "" },
                    }),
                  ]
                ),
              ],
              2
            ),
          ]),
        ]),
        _c("div", { staticClass: "report" }, [
          _c("div", { staticClass: "report-title" }, [_vm._v("项目动态")]),
          _c("div", { staticClass: "report-container" }, [
            _c("div", { staticClass: "report-list-title new" }, [
              _vm._v("新的报告"),
              _c("span", {
                staticClass: "icon-arrow",
                class: _vm.arrowOpen.new ? "open" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeReporetList("new")
                  },
                },
              }),
            ]),
            _c(
              "ul",
              {
                staticClass: "report-list new",
                class: _vm.arrowOpen.new ? "open" : "",
              },
              _vm._l(_vm.reportList.newReport, function (item) {
                return _c(
                  "li",
                  {
                    key: item.inform_id,
                    on: {
                      click: function ($event) {
                        return _vm.gotoReport(item.game_id, item.inform_id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.inform_name))]
                )
              }),
              0
            ),
            _c("div", { staticClass: "report-list-title recent" }, [
              _vm._v("最近打开"),
              _c("span", {
                staticClass: "icon-arrow",
                class: _vm.arrowOpen.recent ? "open" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeReporetList("recent")
                  },
                },
              }),
            ]),
            _c(
              "ul",
              {
                staticClass: "report-list recent",
                class: _vm.arrowOpen.recent ? "open" : "",
              },
              _vm._l(_vm.reportList.recentReport, function (item) {
                return _c(
                  "li",
                  {
                    key: item.inform_id,
                    on: {
                      click: function ($event) {
                        return _vm.gotoReport(item.game_id, item.inform_id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.inform_name))]
                )
              }),
              0
            ),
            _c("div", { staticClass: "report-list-title err" }, [
              _vm._v("上传失败报告"),
              _c("span", {
                staticClass: "icon-arrow",
                class: _vm.arrowOpen.err ? "open" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeReporetList("err")
                  },
                },
              }),
            ]),
            _c(
              "ul",
              {
                staticClass: "report-list err",
                class: _vm.arrowOpen.err ? "open" : "",
              },
              _vm._l(_vm.reportList.errReport, function (item) {
                return _c("li", { key: item.inform_id }, [
                  _vm._v(_vm._s(item.inform_name)),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新建项目",
            visible: _vm.dialogCreate,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCreate = $event
            },
            close: function ($event) {
              _vm.dialogCreate = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c(
                "el-form",
                {
                  ref: "createForm",
                  staticClass: "form-container",
                  attrs: { model: _vm.dialogData },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-left" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目名称:",
                            rules: _vm.projectRule.game_name,
                            prop: "game_name",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "270px" },
                            attrs: {
                              placeholder: "项目名称不能为空(不超过12个字符)",
                            },
                            model: {
                              value: _vm.dialogData.game_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogData, "game_name", $$v)
                              },
                              expression: "dialogData.game_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目描述:",
                            rules: _vm.projectRule.game_desc,
                            prop: "game_desc",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "270px" },
                            attrs: {
                              type: "textarea",
                              placeholder: "项目描述(不超过100个字符)",
                            },
                            model: {
                              value: _vm.dialogData.game_desc,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogData, "game_desc", $$v)
                              },
                              expression: "dialogData.game_desc",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目类型:",
                            rules: _vm.projectRule.root_cate,
                            prop: "root_cate",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "20px",
                              },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeRootCate },
                              model: {
                                value: _vm.dialogData.root_cate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogData, "root_cate", $$v)
                                },
                                expression: "dialogData.root_cate",
                              },
                            },
                            _vm._l(_vm.cateMap, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.dialogData.second_cate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogData, "second_cate", $$v)
                                },
                                expression: "dialogData.second_cate",
                              },
                            },
                            _vm._l(
                              _vm.cateMap[_vm.dialogData.root_cate].children,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-right" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            label: "项目图片:",
                            rules: _vm.projectRule.game_img,
                            prop: "game_img",
                          },
                        },
                        [
                          _c("UploadImg", {
                            attrs: {
                              file: _vm.dialogData.game_img,
                              "data-type": "binary",
                            },
                            on: {
                              "update:file": function ($event) {
                                return _vm.$set(
                                  _vm.dialogData,
                                  "game_img",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "default" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCreate = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createProject },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }